import React, { useState } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import classes from './../TrialstatNoto.module.css';
import TextArea from '../UI/Control/InputTextarea';


function OutcomeEmailChangeReasonModal({ closeModal, saveValue, refreshData }) {
    const [inputValue, setInputValue] = useState('');

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleSave = () => {

        const objCRtext = document.getElementById('txtChangeReason');
        if (objCRtext.value.trim() == '') {
            alert('Please provide a change reason to save the data.');
            objCRtext.focus();
            return false;
        }
        else if (inputValue.trim() != '') {
            saveValue(inputValue.trim());
            refreshData(inputValue);
        }
    };

    return (
        <Modal centered
            show="true"
            onHide={closeModal}
            dialogClassName={classes.TSModalDailog_Six} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title style={{ textAlign: "center" }}>Change Reason</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row mb-3">
                    <div className="col-sm-12">
                        Please provide reason for changes:
                            <TextArea id="txtChangeReason" rows='20' cols='100' style={{ "resize": "none" }} value={inputValue} onChangeHandler={handleChange} />
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>

                <Button className="btn btn-md btn-success" variant="primary" onClick={handleSave}> Submit </Button>
                <Button className="btn btn-md btn-danger" variant="secondary" onClick={closeModal}>
                    Cancel
                    </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OutcomeEmailChangeReasonModal;